export default function mapKnownValues(fromObject: Record<any, any>, values: Record<any, any> | null) {
  if (!values) return fromObject;
  Object.keys(values).forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(fromObject, key)) {
      // Skip anything undefined (intentional)
      if (values[key] === undefined) return;
      // eslint-disable-next-line no-param-reassign
      fromObject[key] = values[key];
    }
  });
  return fromObject;
}
